import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { get } from 'lodash'

import { ReactComponent as LoadingIcon } from '../assets/icons/tabs/authorizing-icon.svg'
import { ReactComponent as FailedIcon } from '../assets/icons/tabs/failed-icon.svg'
import { ReactComponent as SucceededIcon } from '../assets/icons/tabs/approved-icon.svg'
import { ReactComponent as ReadyIcon } from '../assets/icons/tabs/ready-icon.svg'
import { ReactComponent as CreditIcon } from '../assets/icons/tabs/creditcard-icon.svg'

import styles from './AsyncStatusIndicator.module.scss'

const STATUS_ICON_MAP = {
  loading: <LoadingIcon />,
  failed: <FailedIcon />,
  offline: <FailedIcon />,
  succeeded: <SucceededIcon />,
  ready: <ReadyIcon />,
  removeCard: <CreditIcon />,
  noCardReader: <FailedIcon />,
  attached: <FailedIcon />,
}

const getStatusIcon = (status) => {
  return get(STATUS_ICON_MAP, status, null)
}

const AsyncStatusIndicator = ({ className, status, statusText }) => {
  const classNames = cn(styles.asyncStatusIndicator, className)

  if (!status) {
    status = 'ready'
  }

  return (
    <div className={classNames}>
      <div className={styles.outerCircle}>
        <div className={styles.innerCircle}>
          {getStatusIcon(status)}
        </div>
      </div>
      <p className={styles.statusText}>{statusText}</p>
    </div>
  )
}

AsyncStatusIndicator.defaultProps = {
  status: 'ready',
  statusText: '',
}

AsyncStatusIndicator.propTypes = {
  status: PropTypes.oneOf([ 'loading', 'failed', 'succeeded', 'removeCard', 'noCardReader', 'ready' ]),
  statusText: PropTypes.string,
}

export default AsyncStatusIndicator
